<div class="sidebar-root fixed top-0 left-0 z-[55] h-dvh flex flex-col bg-neutral-0 border-r border-neutral-300"
     [class.sidebar-root--open]="isOpen"
     [class.sidebar-root--mobile-hidden]="!isOpen">

  <!-- Header -->
  <div class="flex items-center flex-shrink-0"
       [ngClass]="isOpen ? 'justify-between px-3 py-4' : 'justify-center py-4'">
    @if (isOpen) {
      <img ngSrc="assets/logo-v2.svg" alt="CRM Logo" height="32" width="128" priority>
    }
    <button type="button"
            class="w-11 h-11 flex items-center justify-center rounded-lg hover:bg-neutral-100 active:bg-neutral-200 transition-colors flex-shrink-0"
            (click)="toggle.emit()">
      <span class="custom-icon transition-transform duration-300"
            [class.-rotate-180]="!isOpen"
            inlineSVG="assets/icons/chevron-left.svg"
            style="--width: 16px; --color: #6F94A3">
      </span>
    </button>
  </div>

  <!-- Navigation -->
  <div class="flex flex-col justify-between flex-1 overflow-hidden">
    <div class="flex flex-col gap-1.5 p-3">

      <a [ngClass]="isOpen ? 'nav-link !justify-between' : 'nav-link-icon'"
         routerLink="dashboard" routerLinkActive="bg-neutral-100"
         [pTooltip]="!isOpen ? 'Dashboard' : ''" tooltipPosition="right">
        <div class="flex items-center gap-3">
          <span inlineSVG="assets/icons/dashboard.svg"></span>
          @if (isOpen) { <p>Dashboard</p> }
        </div>
      </a>

      <!-- Contacts -->
      @if (isOpen) {
        <div class="flex flex-col">
          <a (click)="toggleSublist(sublist, arrowIcon)"
             class="flex justify-between items-center rounded-md hover:bg-neutral-100 px-3.5 h-[35px] transition-colors cursor-pointer">
            <div class="flex justify-start items-center gap-3">
              <span inlineSVG="assets/icons/contact.svg"></span>
              <p class="text-base text-primary-900 font-medium">Contacts</p>
            </div>
            <span inlineSVG="assets/icons/arrow.svg" style="--width: 12px; --color: #6F94A3"
                  class="transition-transform duration-300 mr-1 mt-0.5 custom-icon" #arrowIcon></span>
          </a>
          <div class="flex flex-col gap-2 border-l border-neutral-200 ml-7 mt-2 pl-2 overflow-hidden max-h-96 customTransition"
               #sublist>
            <a class="nav-link" routerLink="contacts/all" routerLinkActive="bg-neutral-100">
              <span inlineSVG="assets/icons/users-2.svg"></span>
              <p>All</p>
            </a>
            <a class="nav-link" routerLink="contacts/lists" routerLinkActive="bg-neutral-100">
              <span inlineSVG="assets/icons/list-plus.svg"></span>
              <p>Lists</p>
            </a>
            <a class="nav-link" routerLink="contacts/review" routerLinkActive="bg-neutral-100">
              <span inlineSVG="assets/icons/review.svg"></span>
              <p>Lotus import</p>
            </a>
          </div>
        </div>
      } @else {
        <a class="nav-link-icon" routerLink="contacts/all"
           [class.bg-neutral-100]="isContactsActive()"
           pTooltip="Contacts" tooltipPosition="right">
          <span inlineSVG="assets/icons/contact.svg"></span>
        </a>
      }

      <a [ngClass]="isOpen ? 'nav-link' : 'nav-link-icon'"
         routerLink="meetings" routerLinkActive="bg-neutral-100"
         [pTooltip]="!isOpen ? 'Meetings & Events' : ''" tooltipPosition="right">
        <span inlineSVG="assets/icons/calendar.svg"></span>
        @if (isOpen) { <p>Meetings & Events</p> }
      </a>

      <a [ngClass]="isOpen ? 'nav-link' : 'nav-link-icon'"
         routerLink="companies" routerLinkActive="bg-neutral-100"
         [pTooltip]="!isOpen ? 'Companies' : ''" tooltipPosition="right">
        <span inlineSVG="assets/icons/building.svg"></span>
        @if (isOpen) { <p>Companies</p> }
      </a>

      <a [ngClass]="isOpen ? 'nav-link' : 'nav-link-icon'"
         routerLink="groups" routerLinkActive="bg-neutral-100"
         [pTooltip]="!isOpen ? 'Groups' : ''" tooltipPosition="right">
        <span inlineSVG="assets/icons/atom.svg"></span>
        @if (isOpen) { <p>Groups</p> }
      </a>

      <a [ngClass]="isOpen ? 'nav-link' : 'nav-link-icon'"
         routerLink="offers" routerLinkActive="bg-neutral-100"
         [pTooltip]="!isOpen ? 'Offers & Pitches' : ''" tooltipPosition="right">
        <span inlineSVG="assets/icons/circle-dollar-sign.svg"></span>
        @if (isOpen) { <p>Offers & Pitches</p> }
      </a>

      <a [ngClass]="isOpen ? 'nav-link' : 'nav-link-icon'"
         routerLink="bd-plannings" routerLinkActive="bg-neutral-100"
         [pTooltip]="!isOpen ? 'BD Plannings' : ''" tooltipPosition="right">
        <span inlineSVG="assets/icons/plane.svg"></span>
        @if (isOpen) { <p>BD Plannings</p> }
      </a>

      @if ((currentUser$ | async)?.person.role === UserRole.ADMIN) {
        <a [ngClass]="isOpen ? 'nav-link' : 'nav-link-icon'"
           routerLink="administration" routerLinkActive="bg-neutral-100"
           [pTooltip]="!isOpen ? 'Administration' : ''" tooltipPosition="right">
          <span inlineSVG="assets/icons/shield.svg"></span>
          @if (isOpen) { <p>Administration</p> }
        </a>
      }
    </div>

    <!-- Bottom links -->
    <div class="flex flex-col border-t border-neutral-200 p-3 gap-2">
      <a [ngClass]="isOpen ? 'nav-link !justify-between' : 'nav-link-icon'"
         (click)="onSupportButtonClick()"
         [class.bg-neutral-100]="isZendeskOpen"
         [pTooltip]="!isOpen ? 'Help & Support' : ''" tooltipPosition="right">
        @if (isOpen) {
          <div class="flex items-center gap-3">
            <span inlineSVG="assets/icons/messages-square.svg"></span>
            <p>Help & Support</p>
          </div>
          <span *ngIf="(unreadMessages | async) as count"
                class="text-[10px] text-red-800 font-semibold bg-red-100 rounded px-1 min-w-[16px] text-center">
            {{ count }}
          </span>
        } @else {
          <span inlineSVG="assets/icons/messages-square.svg"></span>
        }
      </a>

      <a [ngClass]="isOpen ? 'nav-link' : 'nav-link-icon'"
         routerLink="learn-more" routerLinkActive="bg-neutral-100"
         [pTooltip]="!isOpen ? 'Learn more' : ''" tooltipPosition="right">
        <span inlineSVG="assets/icons/help-circle.svg"></span>
        @if (isOpen) { <p>Learn more</p> }
      </a>

      <a [ngClass]="isOpen ? 'nav-link !justify-between' : 'nav-link-icon'"
         (click)="openChangelogFeature()"
         [pTooltip]="!isOpen ? 'What\'s new' : ''" tooltipPosition="right">
        @if (isOpen) {
          <div class="flex items-center gap-3">
            <span inlineSVG="assets/icons/code.svg"></span>
            <p>What's new</p>
          </div>
          @if (shouldDisplayNewBadge('changelog')) {
            <span class="text-[10px] text-violet-800 font-semibold bg-violet-100 rounded px-1">NEW</span>
          }
        } @else {
          <span inlineSVG="assets/icons/code.svg"></span>
        }
      </a>
    </div>
  </div>

  <!-- User section -->
  <div class="flex items-center border-t border-neutral-200"
       [ngClass]="isOpen ? 'justify-between pl-3 pr-2 py-4' : 'justify-center p-3'">
    @if (isOpen) {
      @if (currentUser$ | async; as user) {
        <div class="flex items-center gap-2">
          <crm-avatar-singular [selectedUser]="getCurrentUserAvatar()" [static]="true" [showNameTooltip]="false"/>
          <div class="flex flex-col text-primary-900 w-[130px]">
            <p class="font-semibold truncate"
               [pTooltip]="user.person.getFullName()" tooltipPosition="top"
               [tooltipDisabled]="!utilsService.showTooltip(user.person.getFullName(), 10.80)">
              {{ user.person.getFullName() }}
            </p>
            <p class="text-neutral-700">{{ user.person.role | titlecase }}</p>
          </div>
        </div>
      }
      <button (click)="overlayPanel.toggle($event)" class="btn-ghost btn-positioning" type="button">
        <span [inlineSVG]="'assets/icons/more-horizontal.svg'"></span>
      </button>
    } @else {
      <button type="button" class="rounded-full cursor-pointer hover:opacity-80 transition-opacity"
              (click)="overlayPanel.toggle($event)">
        <crm-avatar-singular [selectedUser]="getCurrentUserAvatar()" [static]="true" [showNameTooltip]="false"/>
      </button>
    }
    <p-overlayPanel #overlayPanel [style]="{ width: '200px' }"
                    [styleClass]="isOpen ? 'custom-overlay-left' : 'custom-overlay-right'">
      <div class="flex flex-col gap-2 p-2">
        <div (click)="overlayPanel.hide()" routerLink="settings"
             class="flex items-center gap-2.5 px-3 h-[35px] hover:bg-neutral-100 active:bg-neutral-200 rounded-lg cursor-pointer">
          <span [inlineSVG]="'assets/icons/settings.svg'" class="custom-icon" style="--color: #1084A1"></span>
          <p class="text-base font-medium text-neutral-900">Settings</p>
        </div>
        <div (click)="logout()"
             class="flex items-center gap-2.5 px-3 h-[35px] hover:bg-neutral-100 active:bg-neutral-200 rounded-lg cursor-pointer">
          <span [inlineSVG]="'assets/icons/log-out.svg'" class="custom-icon" style="--color: #1084A1"></span>
          <p class="text-base font-medium text-neutral-900">Logout</p>
        </div>
      </div>
    </p-overlayPanel>
  </div>
</div>
